import React, { useState, useEffect } from 'react';
import './App.css';
import profile1 from './profiles/profile_1.png';
import profile2 from './profiles/profile_2.png';
import profile3 from './profiles/profile_3.png';
import profile4 from './profiles/profile_4.png';
import profile5 from './profiles/profile_5.png';
import profile6 from './profiles/profile_6.png';

function App() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      {/* Navigation */}
      <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
        <div className="nav-content">
          <div className="nav-links-left">
            <a href="#features">Features</a>
            <a href="#demo">Demo</a>
            <a href="#benchmarks">Benchmarks</a>
          </div>
          <div className="nav-logo">
            <img src="/bottle.png" alt="wetnurse.ai" className="logo-icon" />
            <span className="nav-logo-text">wetnurse.ai</span>
          </div>
          <div className="nav-links-right">
            <a href="#testimonials">Testimonials</a>
            <a href="#pricing">Pricing</a>
            <a href="#contact" className="nav-cta">Get Started</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-badge">v1.0 &mdash; Now Accepting Early Enrollments</div>
          <h1 className="hero-title">
            Your C-suite needs<br />
            <span className="hero-title-accent">round-the-clock care.</span>
          </h1>
          <p className="hero-subtitle">
            Pre-chewed insights. Bite-sized analysis. Soothing market summaries.
            All gently spoon-fed by AI that never loses patience with your executives.
          </p>
          <div className="hero-buttons">
            <button className="btn btn-primary">Enroll Your Executives</button>
            <button className="btn btn-outline">Watch Demo</button>
          </div>
        </div>
        <div className="hero-glow"></div>
      </section>

      {/* Metrics Bar */}
      <section className="metrics">
        <div className="metrics-grid">
          <div className="metric">
            <span className="metric-value">&lt;2s</span>
            <span className="metric-label">Feeding time</span>
          </div>
          <div className="metric">
            <span className="metric-value">500+</span>
            <span className="metric-label">Sources digested</span>
          </div>
          <div className="metric">
            <span className="metric-value">99.7%</span>
            <span className="metric-label">Gentle accuracy</span>
          </div>
          <div className="metric">
            <span className="metric-value">24/7</span>
            <span className="metric-label">Never naps</span>
          </div>
          <div className="metric">
            <span className="metric-value">SOC 2</span>
            <span className="metric-label">Safety certified</span>
          </div>
          <div className="metric">
            <span className="metric-value">50+</span>
            <span className="metric-label">Comfort blankets</span>
          </div>
        </div>
      </section>

      {/* Demo Section */}
      <section className="demo" id="demo">
        <div className="section-content">
          <h2 className="section-title">Pre-Chewed For Their Protection</h2>
          <div className="demo-details">
            <p>Raw data can be scary and confusing for your little leaders.
            That's why wetnurse.ai pre-digests every earnings report, market signal, and competitive threat
            into soft, manageable bites they can handle on their own.</p>
            <p>Our proprietary Gentle Comprehension Engine&trade; works around the clock — reading the hard
            things so they don't have to, summarizing the big words, and presenting everything with
            the patience and warmth your C-suite deserves.</p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      {/* <section className="features" id="features">
        <div className="section-content">
          <h2 className="section-title">Everything Your Little Leaders Need</h2>
          <p className="section-subtitle">
            Gentle, purpose-built tools for executives who shouldn't have to figure things out on their own.
          </p>
          <div className="features-grid">
            {[
              { icon: '&#x1F4CA;', title: 'Picture-Book Dashboards', desc: 'Colorful KPI visuals with simple narratives so your executives can follow along without getting overwhelmed.', tag: 'Analytics' },
              { icon: '&#x1F50D;', title: 'Market Watch &amp; Learn', desc: 'We keep an eye on competitors so your leaders don\'t have to. They have enough on their little plates.', tag: 'Research' },
              { icon: '&#x1F4CB;', title: 'Board Pack Assembly', desc: 'We put together all the documents your executives need, since compiling reports is a lot to ask of them.', tag: 'Automation' },
              { icon: '&#x26A0;&#xFE0F;', title: 'Boo-Boo Prevention', desc: 'Spots strategic, operational, and compliance risks early so your C-suite doesn\'t stumble into anything scary.', tag: 'Risk' },
              { icon: '&#x1F4AC;', title: 'Talking Points', desc: 'Pre-written communications for investors and board members, because crafting messages from scratch can be hard.', tag: 'Communication' },
              { icon: '&#x1F4C8;', title: 'What-If Storytime', desc: 'Walk your executives through different scenarios gently, with projections they can understand at their own pace.', tag: 'Strategy' },
              { icon: '&#x1F512;', title: 'Safety Blanket Security', desc: 'Bank-grade encryption, SSO, and role-based access so your executives can feel safe and protected at all times.', tag: 'Security' },
              { icon: '&#x1F310;', title: 'Pre-Blended Insights', desc: 'We mix together data from all your sources into one easy-to-swallow view. No chewing required.', tag: 'Integration' },
              { icon: '&#x23F0;', title: 'Good Morning Brief', desc: 'A warm, personalized digest waiting for them each morning, covering everything so they don\'t have to look it up themselves.', tag: 'Daily' },
              { icon: '&#x1F91D;', title: 'M&amp;A Hand-Holding', desc: 'Guided due diligence and target screening so your deal team doesn\'t wander off in the wrong direction.', tag: 'Deals' },
              { icon: '&#x1F4CA;', title: 'ESG Gold Stars', desc: 'Track governance metrics and earn compliance gold stars with automated reporting they can proudly show the board.', tag: 'Compliance' },
              { icon: '&#x2728;', title: 'Use Your Words', desc: 'Executives can ask questions in plain English and get patient, sourced answers — no technical skills needed.', tag: 'AI' },
            ].map((feature, i) => (
              <div className="feature-card" key={i}>
                <span className="feature-icon" dangerouslySetInnerHTML={{ __html: feature.icon }} />
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-desc">{feature.desc}</p>
                <span className="feature-tag">{feature.tag}</span>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Benchmarks Section */}
      <section className="benchmarks" id="benchmarks">
        <div className="section-content">
          <h2 className="section-title">Why They Need Us</h2>
          <p className="section-subtitle">
            Purpose-built for executives who deserve attentive, specialized care — not some off-the-shelf chatbot.
          </p>
          <div className="benchmarks-table-wrapper">
            <table className="benchmarks-table">
              <thead>
                <tr>
                  <th>Capability</th>
                  <th className="highlight-col">wetnurse.ai</th>
                  <th>Generic AI Assistants</th>
                  <th>Management Consultants</th>
                  <th>BI Platforms</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Time to Feeding</td>
                  <td className="highlight-col">Seconds</td>
                  <td>Minutes</td>
                  <td>Weeks</td>
                  <td>Hours</td>
                </tr>
                <tr>
                  <td>Understands Their Needs</td>
                  <td className="highlight-col check">&#10003;</td>
                  <td className="cross">&#10007;</td>
                  <td className="check">&#10003;</td>
                  <td className="cross">&#10007;</td>
                </tr>
                <tr>
                  <td>Pre-Digested Output</td>
                  <td className="highlight-col check">&#10003;</td>
                  <td className="cross">&#10007;</td>
                  <td className="check">&#10003;</td>
                  <td className="cross">&#10007;</td>
                </tr>
                <tr>
                  <td>Real-Time Data</td>
                  <td className="highlight-col check">&#10003;</td>
                  <td className="cross">&#10007;</td>
                  <td className="cross">&#10007;</td>
                  <td className="check">&#10003;</td>
                </tr>
                <tr>
                  <td>Cost per Month</td>
                  <td className="highlight-col">$$$</td>
                  <td>$</td>
                  <td>$$$$$$</td>
                  <td>$$$</td>
                </tr>
                <tr>
                  <td>Confidentiality</td>
                  <td className="highlight-col check">&#10003;</td>
                  <td className="cross">&#10007;</td>
                  <td className="check">&#10003;</td>
                  <td className="check">&#10003;</td>
                </tr>
                <tr>
                  <td>24/7 Attentiveness</td>
                  <td className="highlight-col check">&#10003;</td>
                  <td className="check">&#10003;</td>
                  <td className="cross">&#10007;</td>
                  <td className="check">&#10003;</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials" id="testimonials">
        <div className="section-content">
          <h2 className="section-title">Happy, Well-Cared-For Leaders</h2>
          <p className="section-subtitle">
            Hear from happy executives and their caregivers! 
          </p>
          <div className="testimonials-grid">
            {[
              { quote: "Our CEO gets so fussy before board meetings. Wetnurse handles the prep so he's calm, settled, and ready for his big boy presentation.", name: "Sarah Chen", role: "CFO, Meridian Technologies", avatar: profile3 },
              { quote: "I can't start my day without my wetnurse briefing. It's a warm bottle of synergy and I suck it dry.", name: "James Worthington", role: "CEO, Atlas Ventures", avatar: profile1 },
              { quote: "The boo-boo prevention feature spotted a regulatory issue three weeks early and fixed it. Our CRO didn't even have to get off his trampoline.", name: "Dr. Amara Osei", role: "Chief of Staff, Helios Pharmaceuticals", avatar: profile4 },
              { quote: "I get overwhelmed by numbers and charts. Wetnurse walks me through them step by step so I can nod confidently in meetings.", name: "Michael Torres", role: "COO, Nimbus Cloud", avatar: profile2 },
              { quote: "Finally, something that speaks simply enough for the boardroom. No expertise needed! They just click a button and generate pretty little reports.", name: "Elisabeth Kruger", role: "Board Chair, Rhine Capital", avatar: profile5 },
              { quote: "Our Head of Corp Dev used to miss obvious opportunities. Now wetnurse holds his hand through 10x more deal screening. Bless him.", name: "David Park", role: "General Counsel, Apex Holdings", avatar: profile6 },
            ].map((t, i) => (
              <div className="testimonial-card" key={i}>
                <p className="testimonial-quote">&ldquo;{t.quote}&rdquo;</p>
                <div className="testimonial-author">
                  {'avatar' in t && t.avatar ? (
                    <img src={t.avatar} alt={t.name} className="testimonial-avatar" />
                  ) : (
                    <div className="testimonial-avatar">{t.name.split(' ').map(n => n[0]).join('')}</div>
                  )}
                  <div>
                    <div className="testimonial-name">{t.name}</div>
                    <div className="testimonial-role">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing" id="pricing">
        <div className="section-content">
          <h2 className="section-title">Simple Plans for Simple Needs</h2>
          <p className="section-subtitle">
            We keep it easy to understand. Pick the level of care your executives require. No surprises — they don't like those.
          </p>
          <div className="pricing-grid">
            <div className="pricing-card">
              <div className="pricing-tier">Cradle</div>
              <div className="pricing-price">$2,500<span>/mo</span></div>
              <div className="pricing-desc">For the executive who just needs a little help getting through the day.</div>
              <ul className="pricing-features">
                <li>Daily morning bottle (briefing)</li>
                <li>Pre-chewed market feeds</li>
                <li>5 picture-book dashboards</li>
                <li>Email &amp; Slack delivery</li>
                <li>Gentle support</li>
              </ul>
              <button className="btn btn-outline btn-full">Get Started</button>
            </div>
            <div className="pricing-card pricing-card-featured">
              <div className="pricing-popular">Most Popular</div>
              <div className="pricing-tier">Nursery</div>
              <div className="pricing-price">$8,000<span>/mo</span></div>
              <div className="pricing-desc">For when the whole leadership team needs looking after together.</div>
              <ul className="pricing-features">
                <li>Everything in Cradle</li>
                <li>Board pack assembly</li>
                <li>What-if storytime</li>
                <li>Boo-boo prevention</li>
                <li>Up to 10 little seats</li>
                <li>Priority soothing</li>
              </ul>
              <button className="btn btn-primary btn-full">Get Started</button>
            </div>
            <div className="pricing-card">
              <div className="pricing-tier">Guardian</div>
              <div className="pricing-price">Custom</div>
              <div className="pricing-desc">For enterprises with executives who need the most attentive, dedicated care.</div>
              <ul className="pricing-features">
                <li>Everything in Nursery</li>
                <li>M&amp;A hand-holding suite</li>
                <li>Custom comfort blankets</li>
                <li>Dedicated private room</li>
                <li>Unlimited high chairs</li>
                <li>24/7 white-glove swaddling</li>
              </ul>
              <button className="btn btn-outline btn-full">Contact Sales</button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section" id="contact">
        <div className="section-content">
          <h2 className="cta-title">Ready to get your executives the care they deserve?</h2>
          <p className="cta-subtitle">
            Join the waitlist. Limited spots in our program — we give each C-suite the individual attention they need.
          </p>
          <div className="cta-form">
            <input type="email" placeholder="Enter your work email" className="cta-input" />
            <button className="btn btn-primary">Enroll Now</button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/bottle.png" alt="wetnurse.ai" className="logo-icon" />
              <span>wetnurse.ai</span>
            </div>
            <p className="footer-tagline">gentle care for the C-suite</p>
          </div>
          <div className="footer-links">
            <div className="footer-col">
              <h4>Product</h4>
              <a href="#features">Features</a>
              <a href="#pricing">Pricing</a>
              <a href="#demo">Demo</a>
              <a href="#benchmarks">Benchmarks</a>
            </div>
            <div className="footer-col">
              <h4>Company</h4>
              <a href="#about">About</a>
              <a href="#careers">Careers</a>
              <a href="#blog">Blog</a>
              <a href="#press">Press</a>
            </div>
            <div className="footer-col">
              <h4>Legal</h4>
              <a href="#privacy">Privacy</a>
              <a href="#terms">Terms</a>
              <a href="#security">Security</a>
              <a href="#compliance">Compliance</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 wetnurse.ai. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
